/**
 * Get the dynamic logo path based on environment variable
 * Logo naming convention: {PREFIX}_logo.png
 * Example: SRG_logo.png, iNube_logo.png
 * 
 * IMPORTANT: Make sure the logo file exists in src/assets/images/
 * Set REACT_APP_LOGO_PREFIX in .env to match your logo filename
 */
export const getLogoPath = () => {
  const logoPrefix = process.env.REACT_APP_LOGO_PREFIX || 'iNube';
  const logoFileName = `${logoPrefix}_logo.png`;
  
  try {
    return require(`../assets/images/${logoFileName}`);
  } catch (error) {
    throw new Error(
      `Logo file not found: ${logoFileName}\n` +
      `Please ensure the file exists at: src/assets/images/${logoFileName}\n` +
      `Current REACT_APP_LOGO_PREFIX: ${logoPrefix}`
    );
  }
};

export default getLogoPath;
